import cloneDeep from "lodash-es/cloneDeep"

import {getters as cartGetters} from 'vue-src/store/modules/cart'

const getters = {};
for (const [key, getterFn] of Object.entries(cartGetters)) {
  // Wrap cart module's getter functions. Each getter will be called with the cart value from this
  // module's state. This will only work as long as all of the cart getters _never_ rely on the
  // second argument, getters.
  getters[key] = function(state) {
    return getterFn.call(null, state.cart);
  }
}

export default {
  namespaced: true,
  state: function() {
    return {cart: null};
  },
  getters,
  mutations: {
    create(state, cart) {
      state.cart = cart;
    },
    clear(state) {
      state.cart = null;
    },
  },
  actions: {
    create({commit, rootState}) {
      const cart = Object.freeze(cloneDeep(rootState.cart));
      commit('create', cart);
    },
  },
};



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/persistent/modules/order.js